import _ from 'lodash';

const instanceConfig = require(
  `../@${process.env.REACT_APP_TENANT}/config.js`
).default;

export function prepareConfig(config, sale_country) {
  if (
    !sale_country ||
    !config.saleCountryOverride ||
    typeof config.saleCountryOverride[sale_country] === 'undefined'
  )
    return config;
  return Object.assign({}, config, config.saleCountryOverride[sale_country]);
}

export function getSaleCountry(tenantData, userClaims, sale) {
  const saleOfferData = // can be both salestore and saleeditstore
    (!!sale && !!sale.saleEdit
      ? sale.saleEdit.offerData
      : (sale || {}).offerData) || {};

  return (
    saleOfferData.sale_country ||
    (userClaims || {}).sale_country ||
    (tenantData || {}).sale_country
  );
}

// runtimeConfig - from sales process dashboard endpoint
// instanceConfig - from src/@tenant/config.js - supports sale_country from user management
// tenantConfig - from user management
export function prepareTenantConfig(runtimeConfig, tenantData) {
  const saleCountry = getSaleCountry(tenantData);

  const { saleCountryOverride = {}, ...generalInstanceConfig } = instanceConfig;

  return _.merge(
    {},
    generalInstanceConfig,
    saleCountryOverride[saleCountry || 'de'],
    runtimeConfig,
    (tenantData || {}).dashboard,
    { features: (tenantData || {}).features }
  );
}

// runtimeConfig - from sales process dashboard endpoint
// instanceConfig - from src/@tenant/config.js - supports sale_country from user management
// tenantConfig - from user management
export function prepareUserConfig(runtimeConfig, tenantData, userClaims) {
  const saleCountry = getSaleCountry(tenantData, userClaims);

  const { saleCountryOverride = {}, ...generalInstanceConfig } = instanceConfig;

  return _.merge(
    {},
    generalInstanceConfig,
    saleCountryOverride[saleCountry || 'de'],
    runtimeConfig,
    (tenantData || {}).dashboard,
    { features: (tenantData || {}).features }
  );
}

export function prepareSaleConfig(runtimeConfig, tenantData, userClaims, sale) {
  const saleCountry = getSaleCountry(tenantData, userClaims, sale);

  const { saleCountryOverride = {}, ...generalInstanceConfig } = instanceConfig;

  return {
    ...generalInstanceConfig,
    ...(saleCountryOverride[saleCountry || 'de'] || {}),
    ...runtimeConfig,
    ...((tenantData || {}).dashboard || {}),
    ...{
      features: (sale || {}).features,
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/helpers/prepareConfig.js